import useThemeStore from '@cobliteam/dashboard/src/store/useThemeStore';
import { useLayoutEffect } from 'react';

// O switch fica no menu do usuário.
const ThemeSync = () => {
  const isDark = useThemeStore((state) => state.theme === 'dark');

  useLayoutEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  return null;
};

export default ThemeSync;
